export enum UserTypesEnum {
  INDIVIDUAL,
  BROKER,
  COMPOUND_DEVELOPER,
  SMALL_DEVELOPER,
  ALL_TYPES,
  BUYER,
}

export enum UserPermissionsEnum {
  MANAGE_LISTINGS = 'MANAGE_LISTINGS',
  MANAGE_LEADS = 'MANAGE_LEADS',
}
